import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux"
import { FormattedMessage } from "react-intl";
import Radio, { RadioGroup } from "@sterling-react/radio";
import { MfaPageContainer } from "./MfaPageContainer";
import { navigateToLogin } from "../../redux/helpers/navigators";
import { MfaType } from "./model/MfaType";
import { answerMfaChoiceChallenge } from "../../redux/actions/loginactioncreators";
import PropTypes from "prop-types";

export default function MfaChoice() {
  const defaultMfaType = MfaType.TOTP;
  const dispatch = useDispatch();
  const [mfaTypeSelected, setMfaTypeSelected] = useState(defaultMfaType);
  const mfaChallenge = useSelector((state) => state.loginForm.challenge);

  const allowChoice = (mfaType) => {
    return mfaChallenge.challengeParameters.includes(mfaType.toUpperCase());
  }

  const mfaTypeArray = [
    {
      type: MfaType.TOTP,
      label: <FormattedMessage id="mfaChoice.totp" defaultMessage="Use your Time-Based One-Time Password authenticator" description="The option to use time-based one time passwords generated by software running on a mobile device" />,
      visible: allowChoice(MfaType.TOTP)
    },
    {
      type: MfaType.SMS,
      label: <FormattedMessage id="mfaChoice.sms" defaultMessage="Receive Code via SMS" description="The option to use one time passwords received by text message to a mobile device" />,
      visible: allowChoice(MfaType.SMS)
    },
    {
      type: MfaType.EMAIL,
      label: <FormattedMessage id="mfaChoice.email" defaultMessage="Receive Code via Email" description="The option to receive one time passwords by email" />,
      visible: allowChoice(MfaType.EMAIL)
    },
  ]

  const handleClickBack = () => {
    navigateToLogin();
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(answerMfaChoiceChallenge({ deliveryMedium: mfaTypeSelected.toUpperCase() }));
  }

  const MfaTypes = (props) => {
    const onclickFn = (e) => {
      if (typeof props.onClick === "function") {
        props.onClick(e.target.value);
      }
    }
    return (
      <RadioGroup
        divClassName=""
        ariaLabel={"Choose multi-factor authentication"}
        name="mfaType"
        labelClassName=""
      >
        {props.mfaTypeArray.filter((item) => item.visible)
          .map((item) => {
            const { type, label } = item;
            if (!mfaTypeSelected) { setMfaTypeSelected(type); }

            return (
              <Radio
                key={type}
                id={type + "Radio"}
                labelClassName="mx-1"
                value={type}
                onClick={onclickFn}
                label={label}
                checked={type === mfaTypeSelected}
              />
            )
          })}
      </RadioGroup>
    )
  }
  MfaTypes.propTypes = {
    onClick: PropTypes.func.isRequired,
    mfaTypeArray: PropTypes.arrayOf(PropTypes.string).isRequired,
  }

  return (
    <MfaPageContainer
      onSubmit={handleSubmit}
      showErrors={true}
      headerText={<FormattedMessage id="mfaChoice.title" defaultMessage="Select Your Preferred Method" description="The title text for a page with a list of multi-factor authentication choices" />}
      instructionalText={<FormattedMessage id="mfaChoice.blurb" defaultMessage="Select from your configured Multi-Factor Authentication methods below." description="Instructions for selecting a multi-factor authentication option" />}
      submitButtonText={<FormattedMessage id="mfaSetup.continueButton" defaultMessage="Continue" description="Submit multi-factor authentication selection" />}
      secondaryButtonText={<FormattedMessage id="mfaSetup.backButton" defaultMessage="Back" description="Return to login" />}
      secondaryButtonHandler={handleClickBack}
      otpValidator={true}
    >
      <MfaTypes
        id="mfaTypeRadioGroup"
        mfaTypeArray={mfaTypeArray}
        onClick={setMfaTypeSelected}
      />
    </MfaPageContainer>
  )
}